import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-course-live-dsa',
  templateUrl: './course-live-dsa.component.html',
  styleUrls: ['./course-live-dsa.component.scss']
})
export class CourseLiveDSAComponent implements OnInit {
  // course_date_day = environment.course_date_day;
  course_details = environment.course_date_advanced_data_science_and_AI;
  certificateImage = 'assets/img/live-courses/certificate/MasteringDat-Structures.png';
  course_date_month = environment.course_date_month;
  course_class_mode_text = [
    '🔴 Live Interactive Sessions',
    '🎥 Access to Class Recordings',
    '❓Dedicated Doubt Support',
    '🏆 Certification of Completion',
    /*'🛠 Hands-on Project Work',*/
    '🎁 Coding Bootcamp with Exciting Goodies'
  ]
  currentTextIndex: number = 0;
  classFeature: string = this.course_class_mode_text[this.currentTextIndex];
  mentor = {
    name: 'Soumya Sambit Mangaraj',
    title2: 'Ex- Goldman Sachs, PayPal',
    title: 'Oracle Cloud Infrastructure',
    image: 'assets/img/live-courses/SOMYA.jpg', // Update with actual image path
    linkedinUrl: 'https://www.linkedin.com/in/soumya-sambit-mangaraj/'
  };

  stats = [
    { value: '5,000+', label: 'Students Mentored' },
    { value: 'Oracle Cloud Infrastructure', label: 'Senior Software Engineer' },
    
  ];
  constructor(
    private modalService: ModalService) { }

  ngOnInit(): void {
  
    setInterval(() => {
      this.currentTextIndex = (this.currentTextIndex + 1) % this.course_class_mode_text.length;
      this.classFeature = this.course_class_mode_text[this.currentTextIndex];
    }, 3000);
  }

  moduleArray = [
    {
      id: 1,
      active: false,
      courseTopic: 'Fundamentals, Arrays & Strings',
      timeTaking: '1st week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
              module_description: 'Establish a strong problem-solving foundation and tackle curated problems on Arrays & Strings to enhance your coding skills and logical thinking.',
          moduleContant: [
            'Loops: For, While, Do-While, Nested Loops',

            'Time & Space Complexity Analysis, Notations',

            'Arrays: Basics, Operations, and Applications',

            'Strings: Manipulation, Pattern Matching, and Anagrams',

            'Two Pointers and Sliding Window Techniques',

            'Recursion: Concepts, Use Cases, and Optimization',

            'Prefix Sum and Difference Array Techniques',

            'Kadane’s Algorithm for Maximum Subarray Sum'

          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                  'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 2,
      active: false,
      courseTopic: 'Sorting, Searching & Linked Lists',
      timeTaking: '2nd Week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
              module_description: 'Build a solid understanding of sorting, searching algorithms & LinkedLists, tackle curated problems, and optimize your approach for efficient problem-solving',
          moduleContant: [
              'Sorting Algorithms: Different Sorting Algorithms including Quick, Merge, Selection and Others',
              'In-Place vs Out-of-Place Sorting: Space Complexity Trade-offs',
              'Binary Search Basics: Iterative & Recursive Implementations',
              'Binary Search Variations: Upper Bound, Lower Bound, First & Last Occurrence',
              'Rotated Sorted Array Search: Finding Pivot, Searching in Rotated Arrays',
              'Applications in Real-world Problems: Search in Infinite Sorted Array, Peak Element',
              'Fast-Slow Pointers: Detecting Cycle using Floyd’s Algorithm',
              'Linked Lists and Its Applications: Iteration, Reverse, Merge, Cycle Detection and Others'
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice'
              ]
            }

          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 3,
      active: false,
      courseTopic: 'Stacks, Queues & Trees',
      timeTaking: '3rd Week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
          module_description: 'Dive into the core principles of Machine Learning with our module, exploring fundamental algorithms and techniques to empower your understanding and application of this transformative field.',
          moduleContant: [
            'Stacks: Stacks & Its applications',
            'Next Greater Element: Uses monotonic stacks for efficient computation',
            'Min Stack: Optimized approach for retrieving the minimum element in O(1)',
            'Largest Rectangle in Histogram: Solves maximum area problems using stacks',
            'Queues: Queues & Its applications',
            'Implemented using arrays, linked lists, or heaps',
            'Circular Queue: Optimized space usage by wrapping around',
            'Deque (Double-Ended Queue): Supports push/pop from both ends, useful in Sliding Window Maximum',
            'Priority Queue: Uses heaps for efficient ordering, applied in scheduling and shortest path problems',
            'LRU Cache Implementation: Combines queue + hashing for efficient cache management'
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice'
              ]
            }

          ],

          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 4,
      active: false,
      courseTopic: 'Graphs',
      timeTaking: '4th Week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
              module_description: `Dive into the cutting edge of Advanced DSA & Graph Algorithms, mastering sophisticated problem-solving techniques, dynamic programming, and graph-based approaches to efficiently solve complex challenges and optimize diverse computational tasks.`,
          moduleContant: [
            'Adjacency List vs Adjacency Matrix: Differences, Space & Time Complexity',
            'Directed vs Undirected Graphs, Weighted vs Unweighted Graphs',
            'Breadth-First Search (BFS): Level-wise traversal, Cycle Detection in Undirected Graphs',
            'Depth-First Search (DFS): Recursive & Iterative approach, Cycle Detection in Directed Graphs',
            'Dijkstra’s Algorithm: Single-source shortest path, Priority Queue Optimizations',
            'Kruskal’s Algorithm: Greedy approach using Disjoint Set Union (DSU)',
            'Prim’s Algorithm: Greedy approach using Priority Queue'
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice.'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
    {
      id: 5,
      active: false,
      courseTopic: 'Dynamic Programming (DP)',
      timeTaking: '5th Week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
              module_description: `Immerse yourself in the world of Advanced Dynamic Programming, mastering recursive optimization, state transitions, and memoization techniques to efficiently tackle complex computational problems and enhance algorithmic efficiency across diverse applications..`,
          moduleContant: [
            'Introduction to DP: Understanding Overlapping Subproblems & Optimal Substructure',
            'Recursion vs DP: Why DP is needed & how it optimizes recursion',
            'Top-Down Approach (Memoization): Storing intermediate results to avoid recomputation',
            'Bottom-Up Approach (Tabulation): Iterative approach to solve DP problems efficiently',
            '1D DP Problems, Knapsack Variants, DP on Subsequences, String, Tree & Graphs'
          ],
          project: [
                  {
                      projectName: '',
                      title: '',
                      pType: [
                          'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice.'
                      ]
                  }
              ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
    {
      id: 6,
      active: false,
      courseTopic: 'Advanced Problem Solving & Optimization',
      timeTaking: '6th Week',
      isProjectInclude:false,
      childProperties: [
        {
          id: 1,
              module_description: `Delve into Advanced Problem-Solving & Optimization, exploring intricate Graph and Dynamic Programming challenges, innovative optimization methods, and practical coding strategies to efficiently tackle complex problems and elevate algorithmic efficiency across various applications.`,
          moduleContant: [
            'Complex Graph & Dynamic Programming Problems',
            'Optimization Strategies for Efficient Solutions',
            'Optimizing for Large Inputs & Edge Cases',
            'Coding Assessment & Hackathons'
          ],
          project: [
            {
              projectName: 'Project 1',
              title: 'Text Generation Playground',
              pType: [
                'Solve 5+ problems daily during class based on complexity, supplemented with daily coding assessments for practice.'
              ]
            }

          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    }
  ]

  toggleCourseTitle(selectedData, index) {
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
  }

  downloadBroucher() {
    this.modalService.openModal();
  }
}
